import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import type { ChatMessage } from '@/types/chat';

interface ChatHistoryProps {
  messages: ChatMessage[];
}

export const ChatHistory = ({ messages }: ChatHistoryProps) => {
  return (
    <div className="flex flex-col gap-4">
      {messages.map((message) => (
        <div
          key={message.id}
          className={`flex flex-col ${
            message.role === 'assistant' ? 'items-start' : 'items-end'
          }`}
        >
          <div
            className={`max-w-[80%] rounded-lg p-3 ${
              message.role === 'assistant'
                ? 'bg-secondary'
                : 'bg-primary text-primary-foreground'
            }`}
          >
            <p className="whitespace-pre-wrap">{message.content}</p>
          </div>
          <span className="text-xs text-muted-foreground mt-1">
            {format(message.timestamp, 'dd MMMM yyyy HH:mm', { locale: ru })}
          </span>
        </div>
      ))}
    </div>
  );
};